var map = {
	"./gps.svg": 4500,
	"./headphones.svg": 4929,
	"./homepage-decor-1.svg": 1486,
	"./homepage-decor-2.svg": 2205,
	"./homepage-decor-top.svg": 5330,
	"./phone.svg": 9788,
	"./spot-marker-dark.svg": 9708,
	"./spot-marker-light.svg": 180,
	"./texture.svg": 2521
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7856;